/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Avatar, Box, Stack, Card } from "@mui/material";

const CompanyCard = ({ name, phone, taxId, address, logoPath, bannerPath }) => {
  const bannerHolder = css({
    flex: 1,
    maxHeight: "130px",
    aspectRatio: '42/13',
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)",
    borderRadius: "10px",
    img: { objectFit: "cover", width: "100%", height: "100%" },
  });

  const comCard = css({
    flex: 1,
    padding: "15px",
    backgroundColor: "#f5f5f5",
    borderRadius: "10px",
    h3: { margin: 0 },
    fontSize: "14px",
  });

  return (
    <Stack direction={{xs:"column", sm:"row"}} spacing={2}>
      <Card css={bannerHolder}>
        <img alt="banner" src={bannerPath} />
      </Card>
      <Stack direction="row" css={comCard}>
        <Avatar sx={{ width: 100, height: 100 }} src={logoPath}>
          Logo
        </Avatar>
        <Stack sx={{ marginLeft: "20px", justifyContent: "space-between" }}>
          <h3>{name}</h3>
          <Box>{`電話：${phone}`}</Box>
          <Box>{`統一編號：${taxId}`}</Box>
          <Box>{`地址：${address}`}</Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CompanyCard;
